import React from 'react';
import { Tooltip } from 'antd';
import { EMPTY_VALUE_PLACEHOLDER } from "../../const/system";



const makeCollapsedText = (item, maxLength) => {
  if (item && item.length > maxLength) {
    return item.slice(0, maxLength) + '...';
  }
  return item ?? EMPTY_VALUE_PLACEHOLDER;
};

const CollapsibleText = ({
   text,
   maxLength = 40,
   size = '',
   customStyle = {},
 }) => {
  const content = makeCollapsedText(text, maxLength);
  const styles = { fontSize: size, whiteSpace: 'pre-wrap',...customStyle };

  return (
    <>
    {text && text.length > maxLength ? (
      <Tooltip title={text}>
        <span className='hp-cursor-pointer' style={styles}>
          {content}
        </span>
      </Tooltip>
    ) : <span style={styles}>{content}</span>}
    </>
  )};

export default CollapsibleText;
